<div class="wrapper">
  @if (dataSource?.tableConfig?.title) {
    <div class="table-header">
      <h1>{{ dataSource.tableConfig.title }}</h1>
      @if (archiveConfig) {
        <a href="javascript:void(0)" (click)="navigate()">
          <i class="fas fa-database" matTooltip="All requests"></i>
        </a>
      }
    </div>
  }

  <app-main-table-v2-tabs [dataTable]="dataSource"></app-main-table-v2-tabs>

  <app-app-table-individual-informations [code]="dataSource?.tableConfig.code"></app-app-table-individual-informations>
  <app-table-filter-v2 [dataSource]="dataSource" [menuConfig]="menuConfig"></app-table-filter-v2>

  <app-main-table-v2-aggs [dataSource]="dataSource"></app-main-table-v2-aggs>

  <app-table-actions-bar-v2 [dataSource]="dataSource"></app-table-actions-bar-v2>

  <app-main-table-content-v2 [dataSource]="dataSource"> </app-main-table-content-v2>

  <app-main-table-v2-paginator-decorator [dataSource]="dataSource"></app-main-table-v2-paginator-decorator>
</div>
